import Banner from '@/components/banner'
import FeaturedServicesCard from '@/components/card/featuredServicesCard'
import Plans from '@/components/plans/plans'
import {
  CircleSmilePlusIcon,
  HouseWifiIcon,
  LpeIcon,
  Search,
  TechSupportIcon,
} from '@/components/svg'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

const cardData = [
  {
    title: 'Designed to\nbe easy.',
    description:
      'Simple plans tailored for home and small business. Sign up online in minutes.',
    icon: <CircleSmilePlusIcon size={140} />,
  },
  {
    title: 'High speed\nnetwork.',
    description:
      'Keep connected to what matters most with our fast, reliable network.',
    icon: <HouseWifiIcon size={140} />,
  },
  {
    title: 'No Lock-In\nContracts.',
    description: 'Giving you peace of mind and making it easier',
    icon: <TechSupportIcon size={140} />,
  },
]

function RouteComponent() {
  return (
    <>
      <Banner
        backgroundUrl="/img/hero_banner.jpg"
        containerStyle="flex flex-1 pt-12 lg:py-12 flex-col banner-gradient min-h-[450px] lg:min-h-[600px] overflow-visible"
      >
        <div className="flex-1 breakpoint-container z-30 relative mb-10 lg:mb-60">
          <img
            src="/img/logo_stacked.svg"
            alt={WHOLESALERNAME}
            className="h-[105px] lg:h-[115px] w-auto object-contain"
          />

          <h1 className="text-white text-[42px] sm:text-[52px] lg:text-[57px] leading-14 lg:leading-16 font-secondary mt-10 lg:mt-14">
            No gimmicks <br />
            just low-priced, <br />
            reliable broadband.
          </h1>
        </div>

        <div className="flex breakpoint-container z-30 relative mb-10 justify-center md:justify-start lg:mb-0">
          <div className="bg-gradient-primary z-30 rounded-2xl max-w-[460px] lg:max-w-[400px] xl:max-w-[460px] p-10 lg:absolute lg:-top-[180px]">
            <p className="text-white text-2xl font-bold">
              Choose the right loyalty plan to suit your household.
            </p>
            <hr className="bg-white h-0.5" />
            <p className="text-[40px] font-black leading-tight">
              Unlimited Highspeed
            </p>
            <p className="text-white text-3xl leading-tight leading font-extrabold">
              options from just
            </p>
            <p className="text-6xl font-black leading-normal">$69.99</p>
            <p className="text-white text-2xl font-bold leading-tight">
              per month for all LPE customers.
            </p>
          </div>
        </div>
        <div className="bg-secondary z-10 relative">
          <div className="flex justify-end w-full breakpoint-container py-10">
            <Link
              to="/sign-up"
              className="flex search-link bg-white rounded-full p-2 justify-between items-center w-full lg:w-[55%] xl:w-[60%] no-underline"
            >
              <p className="font-black text-3xl ml-2 truncate whitespace-nowrap overflow-hidden">
                Check your address here
              </p>
              <Search size={35} />
            </Link>
          </div>
        </div>
      </Banner>

      <div className="content-container">
        <div className="breakpoint-container flex flex-col">
          <h1 className="content-title self-center">Why LPE?</h1>
          <div className="card-row-container flex-wrap lg:flex-nowrap">
            {cardData.map((data, index) => (
              <FeaturedServicesCard
                key={index}
                containerStyle="md:max-w-[48%] lg:max-w-none"
                cardData={data}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="content-container bg-gradient-primary relative  overflow-x-clip min-h-[617px]">
        <div className="absolute -right-[250px] -top-[30px] sm:-top-[100px]">
          <LpeIcon size={500} color="#04124D" />
        </div>
        <div className="breakpoint-container relative z-10">
          <h1 className="content-title self-start text-white">
            Choose the plan that is right for you
          </h1>
          <Plans />
        </div>
      </div>
    </>
  )
}
